import React from 'react'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
import { reduxForm } from 'redux-form'

import { roleColumns } from '../data'
import ModalAddUser from '../ModalAddUser'
import { 
  validateRoleAdminReport, 
  fetchReportRoles, 
  updateRoleDataTemp
} from 'ducks/report'
import { 
  MainBodyContent, 
  CustomButton
} from 'components'
import { ReportContainer } from './styled'

const Report = (props) => {
  const { 
    valueForm,
    reportRoles
  } = props

  const [showModalAddUser, setShowModalAddUser] = React.useState(false)

  React.useEffect(()=>{
    props.validateRoleAdminReport(props.history)
    props.fetchReportRoles()
  },[])

  return (
    <MainBodyContent
      headerTitle='Report Roles'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => setShowModalAddUser(true)}
            icon="plus"
            btnColor="gray"
            title="Add"
          />
        </div>
      }
    >
      <br/>
      <ReportContainer>

        <ReactTable
          columns={roleColumns}
          data={reportRoles}
          defaultPageSize={10}
          noDataText='No data'
          previousText={<Icon name='arrow alternate circle left' />}
          nextText={<Icon name='arrow alternate circle right' />}
          className="-striped -highlight"
          getTdProps={(state, rowInfo, column) => {
            return {
              onClick: (e, handleOriginal) => {
                if (rowInfo && column && column.Header !== '') {
                  props.updateRoleDataTemp(rowInfo.original)
                  setShowModalAddUser(true)
                }
                if (handleOriginal) {
                  handleOriginal()
                }
              },
            }
          }}
        />
      </ReportContainer>
      {showModalAddUser&&
      <ModalAddUser 
        onClose={()=>setShowModalAddUser(false)}
        history={props.history}
      />}
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  return ({
    reportRoles: state.report.reportRoles,
  })
}

const mapDispatchToProps = {
  validateRoleAdminReport,
  fetchReportRoles, 
  updateRoleDataTemp
}

const contForm = reduxForm({
  form: 'formReport',
  enableReinitialize: true,
})(Report)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)